import { unwrapResult } from '@reduxjs/toolkit';
import { useCallback } from 'react';
import {
    errorMessageSelector,
    isFetchingOrdersSelector,
    ordersByActiveCustomerSelector,
    ordersSelector,
} from './selectors';
import { clearAllAction, clearErrorsAction, getOrders } from './actions';
import { useAppDispatch, useAppSelector } from '../hooks';
import { AppDispatch } from '../store';

export const useOrderStore = () => {
    const dispatch: AppDispatch = useAppDispatch();
    const orders = useAppSelector(ordersSelector);
    const ordersByActiveCustomer = useAppSelector(ordersByActiveCustomerSelector);
    const isFetching = useAppSelector(isFetchingOrdersSelector);
    const errorMessage = useAppSelector(errorMessageSelector);

    const fetchOrders = useCallback(
        (args: { customerId: number }) => {
            return dispatch(getOrders(args)).then(unwrapResult);
        },
        [dispatch]
    );

    const clearAll = useCallback(
        () => dispatch(clearAllAction()).then(unwrapResult),
        [dispatch]
    );

    const clearErrors = useCallback(
        () => dispatch(clearErrorsAction()).then(unwrapResult),
        [dispatch]
    );

    return {
        isFetching,
        orders,
        ordersByActiveCustomer,
        fetchOrders,
        clearAll,
        clearErrors,
        errorMessage,
    } as const;
};
